import { Paper, Stack, Text, Title } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'

import { useGlobalState } from '@/hooks/useGlobalState'
import { hasOwnPublishedModule } from '@/utils/contentModuleTables'

import { UserManagement } from '../UserManagementScreen/UserManagement'

interface AppUsersPanelProps {
  showTutorialText: boolean
}

export function AppUsersPanel({ showTutorialText = false }: AppUsersPanelProps) {
  const { api } = useGlobalState()
  const cmQuery = useQuery({
    queryKey: ['cm', 'list'],
    queryFn: () => api.getContentModules(),
    placeholderData: [],
  })

  const canInvite = hasOwnPublishedModule(cmQuery.data ?? [])

  return (
    <Stack>
      <Paper radius="md" p="lg" shadow="sm" px="xl">
        <Title order={4}>Invite End Users</Title>

        {!canInvite ? (
          <Text size="md" c="dimmed" mb="md" mt="md">
            After you have completed all other steps of this setup process, please return here to invite End Users to
            Sidekick.
          </Text>
        ) : (
          showTutorialText && (
            <Text size="md" c="dimmed" mb="md" mt="md">
              Invite End Users so they can begin using the Sidekick App. Credentials will be emailed to them right away.
            </Text>
          )
        )}

        <UserManagement role="User" showRoleColumn={false} entityName="End User" canInvite={canInvite} />
      </Paper>
    </Stack>
  )
}
